import ErrorDefinition from "./ErrorDefinition";
import ErrorDefinitionTranslation from "./ErrorDefinitionTranslation";

export default class ErrorLog {
    public id!: number;
    public componentId!: number;
    public startDate!: string;
    public endDate!: string;
    public params!: string;
    public definition!: ErrorDefinition;

    constructor(jsonData?: ErrorLog) {
        if (jsonData) {
            this.id = jsonData.id;
            this.componentId = jsonData.componentId;
            this.startDate = jsonData.startDate;
            this.endDate = jsonData.endDate;
            this.params = jsonData.params;
            this.definition = new ErrorDefinition(jsonData.definition);
        }
    }

    /**
     * Get translation by language (e.g. 'NL' or 'EN') and apply param values.
     * Returns default language ('EN') when another is not available.
     */
    public getTranslation(language: string): ErrorDefinitionTranslation | undefined {
        let translation = this.definition.translations.find((tl: ErrorDefinitionTranslation) => tl.language === language.toUpperCase());
        if (!translation) {
            // No translation found for given language. Use the default 'EN'.
            translation = this.definition.translations.find((tl: ErrorDefinitionTranslation) => tl.language === 'EN');
        }

        if (this.params && translation) {
            translation.title = this.formatParams(translation.title, this.params);
            translation.description = this.formatParams(translation.description, this.params);
            translation.operatorAction = this.formatParams(translation.operatorAction, this.params);
            translation.serviceAction = this.formatParams(translation.serviceAction, this.params);
        }

        return translation;
    }

    private formatParams(source: string, paramValues: string): string {
        // We know the param values are split by ';'
        const paramValuesArr = paramValues.split(';');
        return source.replace(/{(\d+)}/g, (match, idx) => {
            return typeof paramValuesArr[idx] !== 'undefined' && paramValuesArr[idx] !== ''
                ? paramValuesArr[idx]
                : match
                ;
        });
    }
}
